/*
  E-book offert avec l'oreiller.

  Regle : des qu'un oreiller est dans le panier — quelle que soit sa quantite —
  la ligne e-book y figure une fois, a 0 EUR. Plus d'oreiller, plus d'e-book.

  Le client garde la main : s'il retire l'e-book lui-meme, on ne le remet pas
  pendant sa visite. Un panier vide de tout oreiller remet le compteur a zero.
*/
(function () {
  var CFG = window.NoctoraEbookGift;
  if (!CFG || !CFG.variantId) return;

  var nativeFetch = window.fetch.bind(window);
  var routes = window.routes || {};
  var CART_URL = (routes.cart_url || '/cart') + '.js';
  var ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  var CHANGE_URL = (routes.cart_change_url || '/cart/change') + '.js';

  var KEY_ADDED = 'noctora:ebook:added';
  var KEY_REFUSED = 'noctora:ebook:refused';

  var busy = false;

  function flag(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key) === '1';
      if (value) sessionStorage.setItem(key, '1');
      else sessionStorage.removeItem(key);
    } catch (e) {
      /* navigation privee : on se contente du comportement par defaut */
    }
    return false;
  }

  function isPillow(item) {
    return String(item.handle || '').indexOf(CFG.pillowHandleFragment) !== -1;
  }

  function isEbook(item) {
    return item.variant_id === CFG.variantId || item.id === CFG.variantId;
  }

  function post(url, payload) {
    payload.sections = 'cart-drawer,cart-icon-bubble';
    payload.sections_url = window.location.pathname;
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  /*
    On reproduit le rendu de CartDrawer.renderContents sans son open() : la
    synchro peut se declencher au chargement d'une page, ou le tiroir n'a
    aucune raison de s'ouvrir tout seul.
  */
  function renderSections(sections) {
    if (!sections) return;
    [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: null },
    ].forEach(function (section) {
      var html = sections[section.id];
      if (!html) return;
      var target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!target) return;
      var parsed = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (parsed) target.innerHTML = parsed.innerHTML;
    });

    var inner = document.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }

  function sync() {
    if (busy) return Promise.resolve();
    busy = true;

    return nativeFetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var hasPillow = items.some(isPillow);
        var ebookLine = null;
        items.forEach(function (item) {
          if (isEbook(item)) ebookLine = item;
        });

        if (!hasPillow) {
          flag(KEY_ADDED, false);
          flag(KEY_REFUSED, false);
          if (ebookLine) {
            return post(CHANGE_URL, { id: String(ebookLine.key), quantity: 0 }).then(function (res) {
              renderSections(res.sections);
            });
          }
          return null;
        }

        if (ebookLine) {
          flag(KEY_ADDED, true);
          if (ebookLine.quantity !== 1) {
            return post(CHANGE_URL, { id: String(ebookLine.key), quantity: 1 }).then(function (res) {
              renderSections(res.sections);
            });
          }
          return null;
        }

        // Oreiller present, e-book absent : soit il n'a jamais ete ajoute,
        // soit le client vient de le retirer. Le drapeau tranche.
        if (flag(KEY_ADDED)) {
          flag(KEY_ADDED, false);
          flag(KEY_REFUSED, true);
          return null;
        }
        if (flag(KEY_REFUSED)) return null;

        return post(ADD_URL, { items: [{ id: CFG.variantId, quantity: 1 }] }).then(function (res) {
          flag(KEY_ADDED, true);
          renderSections(res.sections);
        });
      })
      .catch(function () {
        /* le panier doit rester utilisable meme si le cadeau echoue */
      })
      .then(function () {
        busy = false;
      });
  }

  /*
    Le theme pilote le panier en AJAX. On se greffe sur ses appels plutot que
    sur ses evenements, dont le nom change d'une version de Dawn a l'autre.
  */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      promise
        .then(function () {
          setTimeout(sync, 80);
        })
        .catch(function () {});
    }
    return promise;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
